import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BdpService } from 'src/app/areas/bdp/bdp.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';

@Component({
  selector: 'sw-role-position',
  templateUrl: './sw-role-position.component.html',
  styleUrls: ['./sw-role-position.component.css']
})
export class SwRolePositionComponent implements OnInit {

  /**
   * 是否展示左侧菜单
   * @ignore
   */
  showLeft:boolean = true  

  /**
   * 选中角色 还是用户
   * @ignore
   */
  userRole: boolean = false;

  /**
   * 用户列表
   * @ignore
   */
  userTree:any = [];

  /**
   * 角色列表
   * @ignore
   */
  roleTree:any = [];

  /**
   * 页面选中的角色
   * @ignore
   */
  checkedRole; 

  /**
   * 页面选中的用户
   * @ignore
   */
  checkedUser; 

    /**
   * 是否显示用户列表
   */
  @Input() isShowUser:boolean=true;  

  /**
   * 选中用户事件 抛出
   */
  @Output() votedUser = new EventEmitter();  

  /**
   * 是否有搜索功能
   */
  @Input() isSearch:boolean=false;  

  /**
   * 搜索功能的初始用户列表
   */
  initUser:any[] 

  /**
   * 搜索功能的初始角色列表
   */
  initRole:any[] 

  /**
   * 搜索功能的搜索内容
   */
  searchWord:string

  /**
   * 选中角色事件 抛出
   */
  @Output() votedRole = new EventEmitter();

  /**
   * 显示隐藏左侧，抛出
   */
  @Output() isShowLeft = new EventEmitter();

  /**
   * @ignore
   * @param service 
   * @param systemId 
   */
  constructor(
    private service : BdpService,
    private systemId:SystemIdService
    ) { }

  /**
   * @ignore
   */
  ngOnInit() {
    this.location()
  }

  /**
   * @ignore
   * 初始化数据
   */
  location(){
    // 初始化岗位数数据
    let params = { "param": { pageSize: 0,isAdminQuery:true }, "entity": {systemId:this.systemId.getSystemId()} }
    this.service.getPositionService().queryPositionPageList(params).subscribe(data => {
        if (data["code"] == 200) {
          let arr = [];
          // 将数据处理成书组件需要的格式
          data["data"]["records"].forEach(e => {  //格式化数据
            if(e.status){ 
              //如果启用
              arr.push({ id: e.id, text: e.positionName, pId: 'Yiji' })
            }
          });
          // 岗位数数据
          this.userTree = arr;
          // 保留原始初始化好的数据
          this.initUser = JSON.parse(JSON.stringify(arr))
        }
      })

    let param =  {"param":{pageSize:0,isAdminQuery:true}, "entity":{systemId:this.systemId.getSystemId()}};//参数
    this.service.getRoleService().queryRolePageList(param).subscribe(data=>{
      if(data["code"] == 200){
        let arr = [];
        // 将数据处理成书组件需要的格式
        data["data"]["records"].forEach(e => {  //格式化数据
          arr.push({ id: e.roleId, text: e.roleName, pId: 'Yiji',isAdmin:e.isAdmin })
        });
        // 角色数数据
        this.roleTree = arr;
        // 保留原始初始化好的数据
        this.initRole = JSON.parse(JSON.stringify(arr))
      }
    })
  }

  /**
   * @ignore
   * @param showLeft 
   * 显示或隐藏左侧的树，切换
   */
  showStyle(showLeft) {
    this.showLeft=!showLeft;
    // 抛出
    this.isShowLeft.emit(this.showLeft)
  }

  /**
   * @ignore
   * 点击某个用户
   * @param event 
   */
  onVotedUser(event){
    // 选中的用户
    this.checkedUser = event;
    // 此时没有选中角色
    this.checkedRole = undefined;
    // 将选中结果抛出
    this.votedUser.emit(event)
  }

  /**
   * @ignore
   * @param event 
   * 点击某个角色
   */
  onVotedRole(event){
    // 选中的角色
    this.checkedRole = event;
    // 此时没有选中用户
    this.checkedUser = undefined;
    // 将选中结果抛出
    this.votedRole.emit(event)
  }

  /**
   * @ignore
   * 点击搜索
   */
  search(){
    if(this.userRole){  
      //为true的时候展示用户
      if(this.searchWord){
        // 刷新树组件数据
        this.userTree = this.initUser.filter(item=>item.text.indexOf(this.searchWord)>=0)
      } else {
        // 刷新树组件数据
        this.userTree = JSON.parse(JSON.stringify(this.initUser))
      }
      
    } else {  
      //搜索角色
      if(this.searchWord){
        // 刷新树组件数据
        this.roleTree = this.initRole.filter(item=>item.text.indexOf(this.searchWord)>=0)
      } else {
        // 刷新树组件数据
        this.roleTree = JSON.parse(JSON.stringify(this.initRole))
      }
    }
  }
}
